import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import $ from 'jquery';
import {toast} from 'react-toastify';

const PdfDownloadButton = ({href, label, className = 'dropdown-item cursor-pointer'}) => {
    const [processing, setProcessing] = useState(false);

    const download = async () => {
        if (processing) {
            return;
        }

        setProcessing(true);

        try {
            const response = await axios.get(href, {
                responseType: 'blob',
            });

            const filename = (response.headers['content-disposition'] || '').match(/filename="?([^";]+)"?/i);
            const url = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename ? filename[1].trim() : 'download.pdf';
            link.addEventListener('click', (event) => event.stopPropagation());
            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(() => URL.revokeObjectURL(url), 60000);
        } catch (error) {
            toast.error('The PDF could not be generated. Please try again.');
        } finally {
            setProcessing(false);
        }
    };

    return (
        <button type="button" className={`pdf-download-button ${className}`} disabled={processing} aria-busy={processing} onClick={download}>
            {processing && <i className="fas fa-spinner fa-spin mr-2" aria-hidden="true" />}
            <span>{processing ? 'Generating PDF…' : label}</span>
        </button>
    );
};

export default PdfDownloadButton;

// Bootstrap handles document clicks before React 16, so cancel its dropdown hide event.
$(document).on('hide.bs.dropdown', '.dropdown', (event) => {
    if (event.clickEvent && $(event.clickEvent.target).closest('.pdf-download-button').closest('.dropdown')[0] === event.currentTarget) {
        event.preventDefault();
    }
});

document.querySelectorAll('.blade-pdf-download-button').forEach((container) => {
    ReactDOM.render(<PdfDownloadButton {...container.dataset} />, container);
});
